<template>
<!-- tickets table-->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.tickets')" :addclass='panelClass'>
		<div id="eny_dashboard_overview" class="pt-8">
			<ejs-tooltip ref="tooltip" target=".e-rowcell.eny-toolip" :beforeRender="beforeRenderTooltip">
				<ejs-grid ref="grid" :dataSource='ticketsData' :allowPaging='true' gridLines='Both' :allowTextWrap='true' height='570' allowSorting='true' :sortSettings='sortOptions' :dataBound="dataBound"
					:pageSettings='pageSettings' :toolbar='toolbar' :rowSelected='rowSelected' :editSettings='editSettings' :actionComplete="actionComplete" :actionBegin="actionBegin" :queryCellInfo="customiseCell">
					<e-columns>
						<e-column field='id' :headerText="$t('eny.ticket_cols.nr')" :isPrimaryKey='true' width='80'></e-column>
						<e-column field='created_at' :headerText="$t('eny.ticket_cols.creation')" type="date" :format='datetimeFormat' width='170'></e-column>
						<e-column field='type' :headerText="$t('eny.ticket_cols.type')" :visible='showTypeFirm' :dataSource='types' foreignKeyValue='label' foreignKeyField='value' width='80'></e-column>
						<e-column field='firm_name' :headerText="$t('eny.ticket_cols.firm')" :visible='showTypeFirm' width='100'></e-column>
						<e-column field='user_id' :headerText="$t('eny.ticket_cols.user_id')" :visible='showTypeFirm' width='100'></e-column>
						<e-column field='surname' :headerText="$t('eny.ticket_cols.surname')" :visible="showName" width='130'></e-column>
						<e-column field='name' :headerText="$t('eny.ticket_cols.firstname')"  :visible="showName" width='130'></e-column>
						<e-column field='phone' :headerText="$t('eny.ticket_cols.phone')"  :visible="showName" width='130'></e-column>
						<e-column field='prio' :headerText="$t('eny.ticket_cols.prio')" :dataSource='prios' foreignKeyValue='label' foreignKeyField='value' width='80'></e-column>
						<e-column field='status' :headerText="$t('eny.ticket_cols.status')" :visible='enyAdmin' width='120' :dataSource='statuses' foreignKeyValue='label' foreignKeyField='value'></e-column>
						<e-column field='request_id' :headerText="$t('eny.ticket_cols.request')" width='80'></e-column>
						<e-column field='due_date' :headerText="$t('eny.ticket_cols.due')" :visible='enyAdmin' type="date" :format='dateFormat' width='90'></e-column>
						<e-column field='text' :headerText="$t('eny.ticket_cols.text')" :width='textFieldWidth'></e-column>
						<e-column field='chanel' :headerText="$t('eny.ticket_cols.chanel')" :visible='enyAdmin' :dataSource='channels' foreignKeyValue='label' foreignKeyField='value' width='100'></e-column>
					</e-columns>
				</ejs-grid>
				<historyGrid v-if="canEdit" :selected='selTicketId' :isAdmin="enyAdmin"></historyGrid>
			</ejs-tooltip>
		</div>
	</panel>
</div>
</template>

<script>
import { GridComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-vue-grids';
import { DataManager, WebApiAdaptor } from "@syncfusion/ej2-data";
import { TooltipComponent } from "@syncfusion/ej2-vue-popups";
import Panel from "../../Base/Panel.vue";
import useNotification from "../../hooks/useNotification";
import useUtils from "../../hooks/useUtils";
import { mapGetters, mapMutations } from 'vuex';
import { createApp } from 'vue'
import DialogTemplate from "./TicketDialog.vue";
import TicketHistory from "./TicketHistory.vue";

class TicketsAdaptor extends WebApiAdaptor
{
	constructor(component)
	{
		super();
		this.component = component;
		this.timeZoneOffsetOnInit = component.timeZoneOffsetOnInit;
	}

	beforeSend(dm, request)
	{
		const xsrfEl=document.getElementsByName('csrf-token')[0];
		request.headers.append("X-CSRF-TOKEN", xsrfEl.content);
		const kc = this.component.$keycloak;
		request.headers.append("Authorization", `Bearer ${kc.token}`);
	}

	processResponse()
	{
		let request, response;
		[response,,,,request] = [...arguments];
		const original = super.processResponse.apply(this, arguments);
		this.component.selTicketId = this.component.oldSelTicketId;//reload history table
		// Show response message if defined.
		if (request?.type === 'POST' || request?.type === 'PUT') {
			if (response) {
				this.component.UPDATE_STATE(response)
			}
		}
		if (original.result) {
			original.result.forEach(entry => {
				entry.due_date = this.timeZoneOffsetOnInit(entry.due_date)
			})
		}
		return original;
	}
}

const dlgTemplate = createApp({}).component('dlgTemplate', DialogTemplate);

export default {
	name: "TicketTable",
	props:  ['filter', 'canEdit'],
	components: {
		'panel': Panel,
		'ejs-grid': GridComponent,
		'e-columns': ColumnsDirective,
		'e-column': ColumnDirective,
		'ejs-tooltip': TooltipComponent,
		'historyGrid': TicketHistory,
	},
	setup() {
		const { showNotification } = useNotification();
		const { timeZoneOffsetOnInit, localTimeWithOffset } = useUtils();
		return {
			showNotification,
			timeZoneOffsetOnInit,
			localTimeWithOffset
		}
	},
	data() {
		let sortOptions = { columns: [
			{ field: 'created_at', direction: 'Descending'},
			{ field: 'surname', direction: 'Ascending' },
			{ field: 'name', direction: 'Ascending' }
		] };
		if (this.$keycloak.hasRealmRole('admin')) {
			sortOptions= { columns: [
				{ field: 'due_date', direction: 'Descending' },
				{ field: 'created_at', direction: 'Descending'}
			] };
		} else if (this.$keycloak.hasRealmRole('customer')) {
			sortOptions= { columns: [
				{ field: 'created_at', direction: 'Descending' }
			] };
		}
		return {
			pageSettings: {pageSizes: true, pageCount: 5, pageSize: 10},
			toolbar: this.canEdit ? ['Add', 'Edit', 'Search'] : '',
			editSettings: this.canEdit ? {
				allowAdding: true,
				allowEditing: true,
				mode: 'Dialog',
				template: function() {
					return { template: dlgTemplate};
				}
			} : {},
			sortOptions,
			opensOnHover: 'Hover',
			dateFormat: {type: 'date', format: 'dd.MM.yyyy'},
			datetimeFormat: {type: 'date', format: 'dd.MM.yyyy HH:mm:ss'},
			types: [
				{ label: this.$t('eny.role_merchant'), value: 'merchant' },
				{ label: this.$t('eny.role_customer'), value: 'customer' },
			],
			prios: JSON.parse(this.$t('eny.tickets_prios')),
			statuses: JSON.parse(this.$t('eny.tickets_statuses')),
			channels: JSON.parse(this.$t('eny.tickets_chanels')),
			ticketsData: [],
			selTicketId: null,
			oldSelTicketId: null
		};
	},
	mounted() {
		this.UPDATE_TYPES(this.types);
		this.UPDATE_CHANELS(this.channels);
		this.UPDATE_PRIOS(this.prios);
		this.UPDATE_STATUSES(this.statuses);
		this.UPDATE_TITLES({
			'type': this.$t('eny.ticket_cols.type'),
			'firm': this.$t('eny.ticket_cols.firm'),
			'name': this.$t('eny.ticket_cols.name'),
			'prio': this.$t('eny.ticket_cols.prio'),
			'status': this.$t('eny.ticket_cols.status'),
			'request': this.$t('eny.ticket_cols.request'),
			'due_date': this.$t('eny.ticket_cols.due'),
			'text': this.$t('eny.ticket_cols.text'),
			'chanel': this.$t('eny.ticket_cols.chanel')
		});
		if (!this.isCustomer) {
			this.reloadTable(this.filter)
		}
	},
	methods: {
		...mapMutations('ticket', ['UPDATE_STATUS', 'UPDATE_TYPES', 'UPDATE_CHANELS', 'UPDATE_TITLES', 'UPDATE_PRIOS', 'UPDATE_STATUSES', 'UPDATE_STATE']),
		rowSelected: function(args) {
			this.selTicketId = args.data.id;
		},
		beforeRenderTooltip: function (args) {//show tooltips for text column
			if (args.target.closest("td")) {
				this.$refs.tooltip.ej2Instances.content = args.target.tooltip;
			}
		},
		reloadTable(filter) {
			this.selTicketId = this.oldSelTicketId = null;
			const userId = this.$route.params.uid ? this.$route.params.uid : this.user.user_id
			if (userId) {
				if (this.enyAdmin && this.$route.params.uid) {
					// All tickets: -1 - ignore filter.
					filter = -1
				}
				this.ticketsData = new DataManager({
					url: "/tickets/filter/" + filter + '/user/' + userId,
					adaptor: new TicketsAdaptor(this),
				})
			}
		},
		actionComplete: function(args) {
			if (args.requestType === 'add' || args.requestType === 'beginEdit') {
				args.dialog.header =args.requestType==='add' ? this.$t('eny.ticket_dlg_title_new') : this.$t('eny.ticket_dlg_title_edit')+args.rowData.id;
				args.dialog.width = 500;
				this.oldSelTicketId=(args.requestType === 'beginEdit') ? this.selTicketId : null;
				this.selTicketId=null;
			}
		},
		actionBegin: function(args) {
			if (args.requestType === 'save') {
				if (!this.validate(args.action, args.data)) {
					args.cancel = true;
				} else {
					args.data.due_date = this.localTimeWithOffset(args.data.due_date);
				}
			} else if (args.requestType === 'beginEdit' && this.filter==3) {//disable editing closed tickets
				args.cancel = true;
			}
		},
		dataBound: function() {
			//disable  edit button for closed tickets
			const editBtnEl=this.$refs.grid?.$el.querySelectorAll('.e-btn-icon.e-edit')[0]?.parentNode;
			if (editBtnEl) {
				(this.filter==3) ? editBtnEl.classList.add('e-disabled') : editBtnEl.classList.remove('e-disabled');
				(this.filter==3) ? editBtnEl.parentNode.classList.add('disablediv') : editBtnEl.parentNode.classList.remove('disablediv');
			}
		},
		customiseCell: function(args) {
			const showLength = this.canEdit ? 39 : 45;
			if (args.column.field === 'text') {
				if (args.cell.innerHTML.length>showLength) {
					args.cell.classList.add('eny-toolip');
					args.cell.tooltip = args.cell.innerHTML;
					args.cell.innerHTML = args.cell.innerHTML.slice(0, showLength) + "...";
				}
			}
		},
		validate: function(action, data) {
			const fieldsToCheck = ['prio', 'text'];
			if (this.enyAdmin) {
				fieldsToCheck.push('status', 'due_date');
			}
			if (action == "add") {
				if (data.type == 'merchant') {
					fieldsToCheck.push('name');
				}
				if (!this.isCustomer) {
					fieldsToCheck.push('request_id');
				}
			}
			let ok = true;
			fieldsToCheck.forEach(item => ok &= this.validator.validate(item))
			return ok;
		},
	},
	computed: {
		...mapGetters('ticket', ['tickets', 'success', 'message', 'validator']),
		...mapGetters('user', ['user']),
		enyAdmin: function() {
			return this.$keycloak.hasRealmRole('admin')
		},
		isCustomer: function() {
			return this.$keycloak.hasRealmRole('customer')
		},
		textFieldWidth: function() {
			return this.canEdit ? 300 : 300;
		},
		panelClass: function() {
			return this.canEdit ? 'max-w-[1600px] my-5 mx-6 p-5' : 'max-w-[1300px] my-5 mx-6 p-5';
		},
		showName: function() {
			return !this.isCustomer && !!this.canEdit;
		},
		showTypeFirm: function() {
			return this.enyAdmin && !!this.canEdit;
		}
	},
	watch: {
		message(value) {
			if (value !== '') {
				const type=this.success ? 'info' : 'error';
				this.showNotification(value, type, 5);
			}
		},
		filter(value) {
			this.reloadTable(value);
		},
		user(value) {
			if (value.user_id != undefined) {
				this.reloadTable(this.filter)
			}
		}
	}
}
</script>

<style>
.e-grid .e-rowcell {
	font-size: 12px;
}
.disablediv {
	pointer-events: none;
	opacity: 0.4;
}

h2 {
	text-align: center;
	margin-bottom: 50px;
}

#box {
	height: 80px;
	position: relative;
	text-align: center;
}
.circletool {
	height: 35px;
	width: 35px;
}
</style>
